import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

import {DropActionModel, SideMenuItemModel, SideMenuModel} from './core/models/sidemenu.model';
import {HomeService} from './home/service/home.service';
import {EnvironmentService} from './core/enviroment/environment.service';
import {GeolocationService} from './core/services/geolocation/geolocation.service';

import {take} from 'rxjs/operators';
import {Navigation, NavigationService, TagGoogleAnalytics} from 'lps-navigation';
import {FacsService} from './facs/service/facs.service';
import {SnackbarService} from './shared/components/snackbar/service/snackbar.service';
import {Subscription} from 'rxjs';
import {LayoutService} from './core/services/layout/layout.service';
import {GoogleTagManagerService} from './core/analytics/google-tag-manager.service';
import {HomeManagerService} from './home/service/home-manager.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  public hasFinishedLoading = false;
  public showSideMenu: boolean;
  public showHeaderMenu = true;
  public showFooter = true;
  public routerAtHome = true;
  public sideMenuItems: SideMenuModel[];
  public sideMenuCollapsed: SideMenuItemModel;
  public envs = this.environmentService.getAllEnvs();
  public showModal = false;
  private openSideMenu = false;
  public facId = '';
  public activeRoute: string;
  public portalUrl: string;
  public crmUrl: string;

  public subjectGeolocation = new Subscription();
  public navigation: Navigation;
  public showNewBrokerProfile;
  public featureQueueList: boolean = this.environmentService.getEnvVar('feature_queue_list') === 'true';
  public featureReleaseNotes: boolean = this.environmentService.getEnvVar('feature_release_notes') === 'true';
  private subscShowFilter = new Subscription();

  constructor(
    private homeSvc: HomeService,
    private homeManagerService: HomeManagerService,
    private environmentService: EnvironmentService,
    private router: Router,
    private navigationService: NavigationService,
    private geolocationService: GeolocationService,
    private service: FacsService,
    private snackbarService: SnackbarService,
    private layoutService: LayoutService,
    private googleTagService: GoogleTagManagerService
  ) {
  }

  get domain() {
    return this.environmentService.getEnvVar('lopes_portal_domain');
  }

  get sideMenuDraggables() {
    return this.homeSvc.sideMenuDraggables;
  }

  ngOnInit() {
    this.portalUrl = this.environmentService.getBasePortalUrl();
    this.crmUrl = this.environmentService.getBaseCrmUrl();
    this.showNewBrokerProfile = this.environmentService.getEnvVar('feature_new_broker_profile');
    this.subjectGeolocation = this.geolocationService.getLocation().subscribe((value: any) => {
      this.getNavigation(value);
      this.getRoute();
    });
    this.listenShowFooter();
    this.hideHeaderMenuBrokerProfile();
  }

  public getNavigation(geolocation: any) {
    this.navigationService.getNavigation('br', geolocation)
      .pipe(take(1))
      .subscribe(
        (navigationResponse) => {
          this.navigation = navigationResponse;
          if (navigationResponse.sidebar) {
            this.homeSvc.getDraggableSidemenuItems(navigationResponse.sidebar.menu);
          }
          this.hasFinishedLoading = true;
          this.setURLBrokerProfile();
        }, () => { this.hasFinishedLoading = true; }
      );
  }

  ngOnDestroy(): void {
    this.subjectGeolocation.unsubscribe();
    this.subscShowFilter.unsubscribe();
  }

  addDashWidget(action: DropActionModel) {
    this.homeSvc.addDashWidget(action);
  }

  toggleSideMenu(): void {
    this.openSideMenu = !this.openSideMenu;
    this.service.setOpen(this.openSideMenu);
    const route = this.router.url;
    if (route === '/home') {
      this.routerAtHome = true;
    } else {
      this.routerAtHome = false;
    }
    this.showSideMenu = !this.showSideMenu;
    this.sideMenuCollapsed = null;
  }

  logout(token?) {
    this.router.navigate(['/']);
    this.homeSvc.clearHomeCrmToken();
  }

  successfulLogin(event: string) {
    if (event) {
      this.router.navigate(['/home']);
    }
  }

  sideMenuAction(event: any) {
    if (event.action) {
      const url = event.action.url;
      if (url === '/home' && !this.isFromCrm()) {
        window.location.href = `${this.crmUrl}/home`;
      }

      this.router.navigate([url]);
    }
  }

  closeModal() {
    this.showModal = false;
  }

  public getURL(data) {
    const route = this.showNewBrokerProfile === 'true' || this.showNewBrokerProfile === true ? '/associado' : '/perfil';
    this.router.navigate([route, data]);
  }

  openFacModal(event) {
    this.facId = event[0].id;
    this.showModal = true;
  }

  getRoute() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd ) {
        if (!event || !event.url) {
          return;
        }
        this.activeRoute = event.url;
      }
    });
  }

  showSnackbar(event) {
    this.snackbarService.show(event.text, event.type, event.time);
  }

  listenShowFooter(): void {
    this.subscShowFilter = this.layoutService.getShowFooter()
    .subscribe(state => this.showFooter = state);
  }

  setURLBrokerProfile() {
    if (sessionStorage.getItem('broker-nickname') && (!this.navigation.userProfile || !this.navigation.userProfile.name)) {
      this.navigation.header.company.url = 'associado/' + sessionStorage.getItem('broker-nickname');
    }
  }

  hideHeaderMenuBrokerProfile() {
    this.router.events.subscribe((value: NavigationEnd) => {
      if (value instanceof NavigationEnd) {
          this.showHeaderMenu = !value.url.includes('associado');      }
    });
  }

  pushTagEvent(tag: TagGoogleAnalytics) {
    this.googleTagService.pushTag(tag);
  }

  private isFromCrm(): boolean {
    return window.location.origin === this.crmUrl;
  }

}
